import styled from 'styled-components';

export const Box = styled.div`
  position: relative;

  &.center {
    .items-swiper-swiper {
      > .swiper-wrapper {
        justify-content: center;
      }
    }
  }

  .items-swiper-slide .btn {
    &:not(.like-pick) {
      width: 100%;
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .swiper-button-autoplay-control,
    .swiper-button-next,
    .swiper-button-prev {
      opacity: 0;
      visibility: hidden;
    }

    &:hover > .swiper-button-autoplay-control,
    &:hover > .swiper-button-prev,
    &:hover > .swiper-button-next {
      opacity: 1;
      visibility: visible;
    }

    &:hover > .swiper-navigation-black {
      .swiper-button-next,
      .swiper-button-prev {
        background-color: rgba(0, 0, 0, 0.7);
      }
    }

    .swiper-navigation-bottom01 {
      text-align: center;
      position: absolute;
      bottom: 1px;
      width: 100%;

      .swiper-button-next,
      .swiper-button-prev {
        opacity: 1;
        visibility: visible;
        position: relative;
        top: auto;
        transform: translateY(0);
      }

      .swiper-button-next {
        right: auto;
        margin-left: 58px;
      }

      .swiper-button-prev {
        left: auto;
        margin-right: 58px;
      }

      .swiper-button-autoplay-control {
        opacity: 1;
        visibility: visible;
        margin-left: 20px;
      }
    }
  }
`;
